import { Action } from 'redux'
import { EventActions } from '../../../reducers/bookingCalendar/actionNames'

const requestDeleteEvent = (eventId: string = null): IRequestUpdateEvent => ({
  eventId,
  type: EventActions.RequestDeleteEvent,
})
const eventWasDeleted = (
  eventId: string,
  roomId?: string,
): IEventWasDeleted => ({
  eventId,
  roomId,
  type: EventActions.EventWasDeleted,
})

export interface IEventWasDeleted extends Action<EventActions.EventWasDeleted> {
  eventId: string
  roomId: string
}

export interface IRequestUpdateEvent
  extends Action<EventActions.RequestDeleteEvent> {
  eventId?: string
}

export { eventWasDeleted }
export default requestDeleteEvent
